import Swiper from "swiper/swiper-bundle";

export default {
  init() {
    const testimonial = new Swiper(".testimonial-gallery .swiper", {
      slidesPerView: 1,
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 1,
        },
      },
      slidesPerGroup: 1,
      spaceBetween: 50,
      navigation: {
        nextEl: ".testimonial-button-next",
        prevEl: ".testimonial-button-prev",
        clickable: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });

    const popularity = new Swiper(".popularity-gallery .swiper", {
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
      slidesPerGroup: 1,
      spaceBetween: 0,
      pagination: {
        el: ".popularity-swiper-pagination",
        clickable: true,
      },
    });

  },
  finalize() { },
};
